import { isNonEmptyArray } from "_helpers";

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

export function formatWithTwoDecimals(val) {
    return Math.floor(parseFloat(val) * 100) / 100;
}
 
export function formatNumbers( value, decimals = 2 ) {
    return value.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export function formatTextReplaceAccents(text){
    return text
        .replace(/\s/g, '')
        .replace(/[àáâãäå]/g, 'a')
        .replace(/æ/g, 'ae')
        .replace(/ç/g, 'c')
        .replace(/[èéêë]/g, 'e')
        .replace(/[ìíîï]/g, 'i')
        .replace(/ñ/g, 'n')
        .replace(/[òóôõö]/g, 'o')
        .replace(/œ/g, 'oe')
        .replace(/[ùúûü]/g, 'u')
        .replace(/[ýÿ]/g, 'y')
        .replace(/\W/g, ''); 
}

export function formatHeadernames(array, displayDates, dataLength, detailledReportValue, formIsSubmitted){
    let [ startDisplayDate, endDisplayDate ] = isNonEmptyArray(displayDates) ? displayDates : ['...', '...'];

    const today = dayjs().format('DD/MM/YYYY');

    const [ displayStart, displayEnd ] = (() => {
        if( dataLength === 0 ) {
            if( !formIsSubmitted ) {
                return ["...", "..."];
            }
        
            if( detailledReportValue ) {
                return ["01/01/1970", today]; 
            }
        
            return [ startDisplayDate, endDisplayDate ]; 
        }
        
        if( detailledReportValue ) {
            return ["01/01/1970", today];
        }
        
        return [ startDisplayDate, endDisplayDate ];
    })();

    return array.map(column => {
        if( !column.groupId && isNonEmptyArray(column.children) ) {
            column.children = column.children.map(col => {
                if( col.field.includes("variation") ) {
                    col.headerName = `Du ${displayStart} au ${displayEnd}`;
                } else if( col.field.includes("start") ) {
                    col.headerName = `Au ${displayStart}`;
                } else if( col.field.includes("end") ) {
                    col.headerName = `Au ${displayEnd}`;
                }
                return col;
            });
        }
        return column;
    })
}